import React from "react";
import { ANALYTICS_CATEGORY } from "../../../helpers/constants";
import { SCREEN } from "./index.content";
import ScreenFull from "../../common/UI/ScreenFull";
import TrackedLink from "../../Analytics/TrackedLink";
import Container from "../../common/UI/Container";
import "./index.scss";

const Idea = () => {
  return (
    <section className="PgESM-I">
      <Container mode="standard">
        <h2 className="PgESM-I__title">
          Obtén ideas para productos en auge y listos para lanzar en Amazon o
          TikTok Shop
        </h2>
        <div className="PgESM-I__content">
          <div className="PgESM-I__info">
            <p className="PgESM-I__boldText">
              Los analistas de Sellerhook (que forma parte de la familia
              AMZScout) están aquí para ayudarte a encontrar posibles
              superventas para vender y seguir cualquier otro criterio que
              tengas en mente. Como resultado, puedes evitar invertir en
              productos con ventas en declive,{" "}
              <b>obtener hasta el 90 % de las ventas</b> en nuevos nichos y
              superar a tus competidores.
            </p>
            <p className="PgESM-I__text">
              Solicita investigación de productos para tu modelo de negocio y
              gama de productos específicos mediante un solo pago o en 4 cuotas
              sin intereses.
            </p>
            <TrackedLink
              classes="PgESM-I__link"
              category={ANALYTICS_CATEGORY.ES}
              action="order your product research"
              path="https://sellerhook.com/?utm_source=site&utm_medium=amzscout&utm_campaign=main_text"
              target
            >
              SOLICITA TU INVESTIGACIÓN DE PRODUCTOS
            </TrackedLink>
          </div>
          <ScreenFull screen={SCREEN} customClasses="PgESM-I-S" />
        </div>
      </Container>
    </section>
  );
};

export default Idea;
